import { RtsScoreRequestDto, RtsScoreResponseDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";

import { RESUME_KEY } from "@/client/constants/query-keys";
import { axios } from "@/client/libs/axios";

export const calculateRtsScore = async (data: { id: string; jobDescription: string }) => {
  const response = await axios.post<RtsScoreResponseDto>(`/resume/${data.id}/rts-score`, {
    jobDescription: data.jobDescription,
  });

  return response.data;
};

export const useRtsScore = () => {
  return useMutation({
    mutationFn: calculateRtsScore,
    mutationKey: [...RESUME_KEY, "rts-score"],
  });
};